import { CasSelect, componentProps } from 'src/compass/shared/components';
import { useRiskManagerOptions } from 'src/compass/application';
import prependAllOption from 'src/compass/shared/util/prependAllOption';
import { emptyOption } from 'src/compass/shared/util/prependEmptyOption';

/*
  The Service Owner filter: All, (None) - customers without a Service Owner, sent as the
  "empty" option's -1 (EntityListRequestBo) - then the Risk Managers and Bus Dev employees, every
  employee the Service Owner select can offer.
*/
export default function ServiceOwnerFilterSelect({
  includeAllOption,
  includeNoneOption,
  includeEmptyOption,
  ...props
}: componentProps) {
  const { options } = useRiskManagerOptions({ includeBusDev: true });

  return <CasSelect {...props} options={prependAllOption([emptyOption('(None)'), ...options])} />;
}
